import React, { FC } from "react";
import { Control } from "react-hook-form";

import IconBase, { IconBaseProps } from "@/components/ui/Form/Filters/components/Icon/IconBase";
import IconControlled from "@/components/ui/Form/Filters/components/Icon/IconControlled";

export interface IconProps extends IconBaseProps {
  control?: Control<any>;
}
const Icon: FC<IconProps> = (args) => {
  return <>{args?.control ? <IconControlled control={args.control} {...args} /> : <IconBase {...args} />}</>;
};
export default Icon;
